<template lang="pug">
    div.layoutWrapper
        v-card.content(elevation="3")
            div

                // Description
                div.description
                    slot(name="title")

                // Form
                slot
</template>

<script>
    import VueTypes from 'vue-types';

    export default {
        props: {
            page: VueTypes.string.def(''),
        },
    };
</script>

<style lang="stylus" scoped>
    @import "../../../assets/style/_variables.styl";

    .layoutWrapper
        min-height: 100%
        min-height: 100vh
        display: flex
        flex-direction: column
        align-items: center
        justify-content: center
        background: linear-gradient(to right, rgb(0, 180, 219), rgb(0, 131, 176));
        color: $theme.black

    >>> a
        color: $theme.white

    .content-wrapper
        display: flex
        justify-content: center
        align-items: center
        padding-top: 30px
        padding-bottom: 30px
        min-height: 560px
        border-radius: 10px

    .content
        width: 480px
        background-color: rgba(255, 255, 255, 0.95)
        padding: 10px 15px 20px

    @media screen and (max-width: $grid-breakpoints.sm - 1)

        .content-wrapper
            padding-top: 10px

        .content-wrapper
            flex: 1 1 auto

        .content
            width: 100%
            padding: 0 5px 20px
</style>
